import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Container, Form, Row, Tabs, Tab } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Logo from "../assets/logo.png";
import BgPage from "../assets/pmo-office.jpg";
import {
  API_ROUTE,
  Login as LoginUser,
  headersRequest,
  Organizations,
} from "../helpers";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import spanish_flag from "../assets/flags/spain.png";
import en_flag from "../assets/flags/united-kingdom.png";
import axios from "axios";

const Login = () => {
  const [t, i18n] = useTranslation("login");
  let actlg = window.localStorage.getItem("idiomaLogin")
    ? window.localStorage.getItem("idiomaLogin")
    : "";
  const [checklg, setChecklg] = useState(actlg);
  const [watch, setwatch] = useState("");
  const [ddlOrganizations, setDdlOrganizations] = useState([]);
  let history = useHistory();

  const credentials = useRef({
    email: null,
    pass: null,
    organization: "",
  });

  const saveDataLocal = (data) => {
    const IdOrg = data.OID || data.IdOrganizacion;
    const IdUser = data.UID || data.IdUsuario;
    localStorage.setItem("tokenuserid", data.message);
    localStorage.setItem("cm9sX3VzdWFyaW8=", data.rol);
    localStorage.setItem("nombreUser", data.nombreUser);
    localStorage.setItem("nombreOrganizacion", data.nombreOrganizacion);
    localStorage.setItem("OID", IdOrg);
    localStorage.setItem("UID", IdUser);
    localStorage.setItem("rol", data.rol);
    localStorage.setItem("idioma", checklg);
    localStorage.setItem("loginMethod", "local");
  };

  const redirAfterLogin = () => {
    let rol = localStorage.getItem("rol");
    if (rol == 81) {
      history.push("/tasks");
    } else {
      history.push("/landing");
    }
  };

  const badLogin = () => {
    swal("¡Ups!", t("login_tittle0"), "error");
    localStorage.clear();
  };

  const successLogin = (data) => {
    saveDataLocal(data);
    redirAfterLogin();
    // hide welcome msg
  };

  const handlelglogin_es = (e) => {
    setChecklg("es");
  };

  const handlelglogin_en = (e) => {
    setChecklg("en");
  };

  useEffect(() => {
    window.localStorage.setItem("idiomaLogin", checklg);
    i18n.changeLanguage(checklg);
  }, [checklg]);

  useEffect(() => {
    Organizations(watch, setDdlOrganizations);
  }, [watch]);

  // Mostrar error si el backend redirigió con ?entra_error=...
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const entraError = params.get("entra_error");
    if (entraError) {
      const errorMessages = {
        org_required:
          "Debes seleccionar una organización antes de ingresar con Microsoft.",
        auth_failed: "No se pudo autenticar con Microsoft. Intenta de nuevo.",
        user_not_found:
          "Tu cuenta de Microsoft no está registrada en el sistema. Contacta al administrador.",
        missing_data:
          "Error en el proceso de autenticación. Contacta al administrador.",
        server_error: "Error interno del servidor. Intenta de nuevo.",
        callback_invalid: "Respuesta de autenticación inválida.",
        config_error:
          "Error de configuración del servidor. Contacta al administrador.",
      };
      const msg =
        errorMessages[entraError] || "Error en autenticación con Microsoft.";
      swal("Error de autenticación", msg, "error");
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleEntraLogin = async () => {
    const org = credentials.current.organization || "";
    if (!org) {
      swal(
        "Organización requerida",
        "Selecciona una organización antes de ingresar con Microsoft.",
        "warning",
      );
      return;
    }
    const [orgId, ...nameParts] = org.split(",");
    const orgName = nameParts.join(",");
    const loginUrl = `${API_ROUTE}auth/entra/login?orgId=${encodeURIComponent(orgId)}&orgName=${encodeURIComponent(orgName)}`;
    /* window.location.assign(loginUrl); */
    // El API devuelve JSON { authUrl } en vez de un 302, para evitar que IIS
    // URL Rewrite (ARR nivel servidor) reescriba el Location header de Microsoft.
    try {
      const res = await fetch(loginUrl, { credentials: "include" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (data.authUrl) {
        window.location.assign(data.authUrl);
      } else {
        swal(
          "Error",
          "No se pudo obtener la URL de autenticación. Intenta de nuevo.",
          "error",
        );
      }
    } catch (err) {
      swal(
        "Error de autenticación",
        "No se pudo conectar con el servidor. Intenta de nuevo.",
        "error",
      );
    }
  };

  return (
    <Container
      fluid
      className="bg-dark"
      style={{
        backgroundImage: `url(${BgPage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            md={{ span: 5, offset: 0 }}
            of
            className="py-5 px-3 bg-white shadow-lg d-flex flex-column justify-content-center"
            style={{ minHeight: "100vh" }}
          >
            <div className="d-flex align-items-end justify-content-start">
              <img src={Logo} alt="Logo" height="70" className="mr-2" />
              <p className="h6 border-left pl-3">
                Cloud <span className="text-primary">Projects</span>
              </p>
            </div>
            <Form>
              {["radio"].map((type) => (
                <div key={`reverse-${type}`} className="my-2 d-flex">
                  <div className="d-flex align-items-center mr-4 ">
                    <Form.Check
                      checked={checklg == "es" || checklg == "" ? true : false}
                      label={t("login_es")}
                      name="group1"
                      type={type}
                      id={`reverse-${type}-1`}
                      onChange={handlelglogin_es}
                    />
                    <img
                      className="ml-2"
                      src={spanish_flag}
                      width={15}
                      height={15}
                      alt="flag"
                    />
                  </div>

                  <div className="d-flex align-items-center ml-4">
                    <Form.Check
                      checked={checklg == "en" ? true : false}
                      label={t("login_en")}
                      name="group1"
                      type={type}
                      id={`reverse-${type}-2`}
                      onChange={handlelglogin_en}
                    />
                    <img
                      className="ml-2"
                      src={en_flag}
                      width={15}
                      height={15}
                      alt="flag"
                    />
                  </div>
                </div>
              ))}
            </Form>
            <Tabs defaultActiveKey="login" className="mt-2">
              <Tab eventKey="login" title={t("login_tittle1")}>
                <h5 className="mt-3">{t("login_tittle1")}</h5>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    LoginUser(credentials.current, successLogin, badLogin);
                  }}
                >
                  <Form.Group controlId="email">
                    <Form.Label>{t("login_mail")}</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder={t("login_textbox_mail")}
                      required
                      onBlurCapture={(e) => {
                        setwatch(e.target.value);
                      }}
                      onChange={(e) => {
                        credentials.current.email = e.target.value;
                      }}
                    />
                  </Form.Group>
                  <Form.Label className="mt-1">
                    {t("login_select_organization")}
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="organizations" //editar de acuerdo a la base
                    className="mb-2"
                    onChange={(e) => {
                      credentials.current.organization = e.target.value;
                    }}
                  >
                    {ddlOrganizations?.length > 0 ? (
                      <>
                        <option value="">
                          {t("login_select_your_organization")}
                        </option>
                        {ddlOrganizations?.map((item) => {
                          return (
                            <option
                              key={item.IdOrganizacion}
                              value={`${item.IdOrganizacion},${item.Organizacion}`}
                            >
                              {item.Organizacion}
                            </option>
                          );
                        })}
                      </>
                    ) : (
                      <option value="">
                        {t("login_select_your_organization")}
                      </option>
                    )}
                  </Form.Control>

                  <Form.Group controlId="pass">
                    <Form.Label>{t("login_tittle_pass")}</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder={t("login_textbox_pass")}
                      onChange={(e) => {
                        credentials.current.pass = e.target.value;
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2" controlId="accept">
                    <span>
                      {t("login_t&C")}{" "}
                      <a
                        href="https://cloudprojects.co.pwc.com/cloudprojectsdocs/files/terminos-y-condiciones-cp.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("login_t&C_1")}
                      </a>
                    </span>
                    <br />
                    <a
                      href="https://projects.co.pwc.com/democloudprojects/recuperarcontrase%C3%B1a.aspx"
                      target="blank"
                    >
                      {t("login_forgotpass")}
                    </a>
                  </Form.Group>
                  <div className="d-flex justify-content-between mt-3">
                    <Button variant="primary" type="submit">
                      {t("login_button")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#D04A02",
                        borderColor: "#ffb600",
                      }}
                      target="_blank"
                      href="https://projects.co.pwc.com/admin-cloud-projects-pro/Registrese.aspx"
                    >
                      {t("login_register")}
                    </Button>
                  </div>

                  <hr className="my-3" />

                  <Button
                    type="button"
                    className="w-100"
                    style={{
                      backgroundColor: "#D04A02",
                      borderColor: "#D04A02",
                      color: "#ffffff",
                      fontWeight: "bold",
                      borderRadius: "0",
                    }}
                    onClick={handleEntraLogin}
                  >
                    Ingresar con Credenciales PwC
                  </Button>
                </Form>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Login;
